import React from 'react';
import { ExtendedTheme, Tooltip } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/core';

const useStyles = makeStyles<ExtendedTheme, StyleProps>((theme: ExtendedTheme) => createStyles({
	textOverlapping: {
		display: 'block',
		whiteSpace: 'nowrap',
		wordWrap: 'break-word',
		lineHeight: theme.typography.body2.lineHeight,
		maxWidth: (props: StyleProps) => props.maxWidth,
		overflow: 'hidden',
		textOverflow: 'ellipsis'
	}
}));

interface StyleProps {
	maxWidth?: number;
}

interface TextOverlappingProps {
	value: string;
	maxLength?: number;
	maxWidth?: number;
}

export const TextOverlapping = ({ value, maxLength, maxWidth = 150 }: TextOverlappingProps) => {
	const classes = useStyles({ maxWidth });

	if (maxLength && value?.length > maxLength) {
		return <Tooltip title={value}>
			<div className={classes.textOverlapping}>{value}</div>
		</Tooltip>
	}

	return <>{value}</>;
};
